import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import {  mainBody, about, repos, contact } from "./editable-stuff/config.js";
import MainBody from "./components/MainBody";
import AboutMe from "./components/AboutMe";
import Projects from "./components/Projects";
import Navbar from "./components/Navbar";
import Contact from "./components/Contact";

const Home = React.forwardRef((props, ref) => {
	return (
		<>
			<MainBody
				title={`${mainBody.firstName} ${mainBody.lastName}`}
				message={mainBody.message}
				gradient={mainBody.gradientColors}				
				icons={mainBody.icons}
				ref={ref}
			/>
			<AboutMe
				heading={about.heading}
				message={about.message}
				link={about.imageLink}
				imgSize={about.imageSize}
			/>
			<Projects
				heading={repos.heading}
				username={repos.gitHubUsername}
				repos={repos.repos}
			/>
			<Contact
				heading={contact.heading}
				message={contact.message}
                email={contact.email}
                discord={contact.discord}
			/>
		</>
	);
});

const App = () => {
	const titleRef = React.useRef();

	return (
		<BrowserRouter basename={process.env.PUBLIC_URL + "/"}>
			<Navbar ref={titleRef} />
			<Route path="/" exact component={() => <Home ref={titleRef} />} />
		</BrowserRouter>
	);
};

export default App;
